import React, { useState, useEffect } from 'react';
import { Loading } from 'carbon-components-react';
import styled from 'styled-components';

// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import StudyListContent from './StudyListContent';
import TileHeader from '../../components/TileHeader/TileHeader';

import NewStudyModal from './NewStudyModal';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import { toaster } from '../../helpers/toaster';
// api
import { getStudyList, deleteStudy, triggerReport } from '../../api/studyListApi';
import usePollReport from '../../hooks/usePollReport';

const StudyList = ({
  user,
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);

  const [studyList, setStudyList] = useState(null);
  const [openNewStudyModal, setOpenNewStudyModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  // const [openSyncModal,setOpenSyncModal] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [openExportModal, setOpenExportModal] = useState(false);
  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Studies report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const refreshTriggered = () => {
    setRefreshData(true);

  }

  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true);
    setDeleteItem(itemId);
  };

  const confirmDelete = () => {
    setOpenDeleteModal(false);
    setLoading(true);
    deleteStudy(deleteItem?.id).then(res => {
      toaster("Study deleted successfully", "success")
      setLoading(false);
      refreshTriggered();
    });
  };

  const showExportConfirm = () =>{
    setOpenExportModal(true);
  }

  const confirmExport = () => {
    setOpenExportModal(false);
    triggerReport('studies')
      .then(({ task_id }) => {
        toaster('Generating studies report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };


  return (
  <Container>
      <ContentContainer>
        <TileHeader 
            title="Studies"
            // subtitle="A list of all studies."
            size="lg"
        />

				{
					loading ? 
					<Loading

          /> 
					:
					<></>
				}

          <StudyListContent
            studyList={studyList}
            setOpenNewStudyModal={setOpenNewStudyModal}
            onDeleteClicked={showDeleteConfirm}
            // onSyncClicked={showSyncConfirm}
            onExportClicked={showExportConfirm}
            reportStatus={reportStatus}
            refresh={refreshData}
            setRefresh={setRefreshData}
            />

        <NewStudyModal
          open={openNewStudyModal}
          refreshStudyList={refreshTriggered}
          onClose={() => setOpenNewStudyModal(false)}
          loading={setLoading}
        />
        <ConfirmModal
          title="Delete Study"
          content={`Are you sure you want to delete Study ${deleteItem?.org_study_id}? This will remove all locations, attachments, and registries associated with it.`}
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          onConfirm={() => confirmDelete()}
        />
        <ConfirmModal
          title="Export Study Data"
          content="Do you want to export study data? This may take awhile. Navigating away from this page will stop the report generation."
          open={openExportModal}
          onClose={() => setOpenExportModal(false)}
          onConfirm={() => confirmExport()}
        />

      </ContentContainer>
    </Container>
  );
};

export default StudyList;